// extracted by mini-css-extract-plugin
export default {"container":"Trending_container__-L+eq","subContainer":"Trending_subContainer__d1OWQ","cardsContainer":"Trending_cardsContainer__9yrPq"};